import {
  opportunitiesTasksListOptions,
  ReturnOpportunityReadable
} from '@crm/api'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { SkeletonWrapper, Text } from '@shared/components'
import { useQuery } from '@tanstack/react-query'
import { Button, Flex } from 'antd'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { OpportunityTaskItem } from './OpportunityTaskItem'

type Props = {
  opportunity?: ReturnOpportunityReadable
}

export const OpportunityCardTasks = ({ opportunity }: Props) => {
  const { t } = useTranslation()
  const { opportunityId } = useParams()
  const navigate = useAppNavigate()

  const { data, isLoading } = useQuery({
    ...opportunitiesTasksListOptions({
      path: {
        opportunity_id: String(opportunityId)
      },
      query: {
        per_page: 3
      }
    }),
    enabled: !!opportunityId
  })

  return (
    <Flex vertical gap={8}>
      <Flex justify="space-between" align="center">
        <Text weight={600}>{t('lead.tasks')}</Text>

        <Button
          color="primary"
          variant="link"
          onClick={() =>
            navigate(
              `${paths.opportunities}/${opportunityId}/details/${opportunity?.lead?.id}/tasks`
            )
          }
        >
          {t('reports.view_all')}
        </Button>
      </Flex>

      <SkeletonWrapper loading={isLoading} paragraph={{ rows: 2 }}>
        <Flex vertical gap={8}>
          {data?.results
            ?.filter((task) => !task.completed_at)
            .map((task) => (
              <OpportunityTaskItem key={task?.id} task={task} />
            ))}
        </Flex>
      </SkeletonWrapper>
    </Flex>
  )
}
